export enum MaintIndicatorEnum {
  AVAILABLE = 'available',
  RESTRICTED = 'restricted',
  UNAVAILABLE = 'unavailable',
}
